// src/ui/components/items/ItemRankingCustom.tsx
import React from 'react';
/* import { FaThumbsUp } from 'react-icons/fa';
import type { SVGProps } from 'react'; */
import ItemParticipant from './Participan';

interface Props {
  img: string;
  name: string;
  rating: string;
  position: number;
}

// Forzamos el tipo correcto para el icono:
//const LikeIcon = FaThumbsUp as React.FC<SVGProps<SVGSVGElement>>;

const ItemRankingCustom: React.FC<Props> = ({ img, name, rating, position }) => {
  return (
    <div className="flex items-center w-full p-4 bg-gray-600/5 shadow hover:shadow-md rounded-[24px]">
      <ItemParticipant img={img} name={`${position}°. ${name}`} direction="row" />

      {/* Puntuación */}
      <div className="ml-auto text-gray-400 hover:text-white">
        <span className="ml-6 mr-4 text-3xl text-white font-bold">{rating}</span>
      </div>
    </div>
  );
};

export default React.memo(ItemRankingCustom);
